// @ts-nocheck
import React, { useContext, useEffect } from "react";
import LoginFooter from '../../components/Footers/LoginFooter';
import AdminHeader from '../../components/Headers/AdminHeader';
import AdvancedExludedEntity from '../../components/AdvancedExludedEntity';
import { useHistory } from "react-router";
import { UserContext } from '../../context/User';

const ExludedEntityPage = () => {
  const { user } = useContext(UserContext);
  const role = user && user.roles && user.roles[0].role_description;
  const history = useHistory();

  useEffect(() => {
    if (role !== "admin") {
      history.push("/dashboard");
    }
  }, []);

  return (
    <>  
      <AdminHeader />
      <main>
        {role === "admin" && <AdvancedExludedEntity />}
      </main>
      <LoginFooter />
    </>
  );
}

export default ExludedEntityPage;